import { c as _c } from "react/compiler-runtime";
import { mergeClasses } from 'minimal-shared/utils';
import Tooltip from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import ButtonBase from '@mui/material/ButtonBase';
import { Iconify } from '../../iconify';
import { createNavItem } from '../utils';
import { navItemStyles, navSectionClasses } from '../styles';

// ----------------------------------------------------------------------

export function NavItem(t0) {
  const $ = _c(77);
  let active;
  let caption;
  let className;
  let depth;
  let disabled;
  let enabledRootRedirect;
  let externalLink;
  let hasChild;
  let icon;
  let info;
  let open;
  let other;
  let path;
  let ref;
  let render;
  let slotProps;
  let title;
  if ($[0] !== t0) {
    ({
      ref,
      path,
      icon,
      info,
      title,
      caption,
      open,
      active,
      disabled,
      depth,
      render,
      hasChild,
      slotProps,
      className,
      externalLink,
      enabledRootRedirect,
      ...other
    } = t0);
    $[0] = t0;
    $[1] = active;
    $[2] = caption;
    $[3] = className;
    $[4] = depth;
    $[5] = disabled;
    $[6] = enabledRootRedirect;
    $[7] = externalLink;
    $[8] = hasChild;
    $[9] = icon;
    $[10] = info;
    $[11] = open;
    $[12] = other;
    $[13] = path;
    $[14] = ref;
    $[15] = render;
    $[16] = slotProps;
    $[17] = title;
  } else {
    active = $[1];
    caption = $[2];
    className = $[3];
    depth = $[4];
    disabled = $[5];
    enabledRootRedirect = $[6];
    externalLink = $[7];
    hasChild = $[8];
    icon = $[9];
    info = $[10];
    open = $[11];
    other = $[12];
    path = $[13];
    ref = $[14];
    render = $[15];
    slotProps = $[16];
    title = $[17];
  }
  let t1;
  if ($[18] !== depth || $[19] !== enabledRootRedirect || $[20] !== externalLink || $[21] !== hasChild || $[22] !== icon || $[23] !== info || $[24] !== path || $[25] !== render) {
    t1 = createNavItem({
      path,
      icon,
      info,
      depth,
      render,
      hasChild,
      externalLink,
      enabledRootRedirect
    });
    $[18] = depth;
    $[19] = enabledRootRedirect;
    $[20] = externalLink;
    $[21] = hasChild;
    $[22] = icon;
    $[23] = info;
    $[24] = path;
    $[25] = render;
    $[26] = t1;
  } else {
    t1 = $[26];
  }
  const navItem = t1;
  const t2 = navItem.rootItem ? "rootItem" : "subItem";
  let t3;
  if ($[27] !== active || $[28] !== disabled || $[29] !== open || $[30] !== t2) {
    t3 = {
      open,
      active,
      disabled,
      variant: t2
    };
    $[27] = active;
    $[28] = disabled;
    $[29] = open;
    $[30] = t2;
    $[31] = t3;
  } else {
    t3 = $[31];
  }
  const ownerState = t3;
  const t4 = navItem.baseProps;
  let t5;
  if ($[32] !== active || $[33] !== className || $[34] !== disabled || $[35] !== open) {
    t5 = mergeClasses([navSectionClasses.item.root, className], {
      [navSectionClasses.state.open]: open,
      [navSectionClasses.state.active]: active,
      [navSectionClasses.state.disabled]: disabled
    });
    $[32] = active;
    $[33] = className;
    $[34] = disabled;
    $[35] = open;
    $[36] = t5;
  } else {
    t5 = $[36];
  }
  let t6;
  if ($[37] !== slotProps?.sx) {
    t6 = Array.isArray(slotProps?.sx) ? slotProps?.sx ?? [] : [slotProps?.sx];
    $[37] = slotProps?.sx;
    $[38] = t6;
  } else {
    t6 = $[38];
  }
  let t7;
  if ($[39] !== t6) {
    t7 = [...t6];
    $[39] = t6;
    $[40] = t7;
  } else {
    t7 = $[40];
  }
  let t8;
  if ($[41] !== icon || $[42] !== navItem.renderIcon || $[43] !== ownerState || $[44] !== slotProps?.icon) {
    t8 = icon && <ItemIcon {...ownerState} className={navSectionClasses.item.icon} sx={slotProps?.icon}>{navItem.renderIcon}</ItemIcon>;
    $[41] = icon;
    $[42] = navItem.renderIcon;
    $[43] = ownerState;
    $[44] = slotProps?.icon;
    $[45] = t8;
  } else {
    t8 = $[45];
  }
  let t9;
  if ($[46] !== ownerState || $[47] !== slotProps?.title || $[48] !== title) {
    t9 = title && <ItemTitle {...ownerState} className={navSectionClasses.item.title} sx={slotProps?.title}>{title}</ItemTitle>;
    $[46] = ownerState;
    $[47] = slotProps?.title;
    $[48] = title;
    $[49] = t9;
  } else {
    t9 = $[49];
  }
  let t10;
  if ($[50] !== caption || $[51] !== ownerState || $[52] !== slotProps?.caption) {
    t10 = caption && <Tooltip title={caption} arrow={true}><ItemCaptionIcon {...ownerState} icon="eva:info-outline" className={navSectionClasses.item.caption} sx={slotProps?.caption} /></Tooltip>;
    $[50] = caption;
    $[51] = ownerState;
    $[52] = slotProps?.caption;
    $[53] = t10;
  } else {
    t10 = $[53];
  }
  let t11;
  if ($[54] !== info || $[55] !== navItem.renderInfo || $[56] !== ownerState || $[57] !== slotProps?.info) {
    t11 = info && <ItemInfo {...ownerState} className={navSectionClasses.item.info} sx={slotProps?.info}>{navItem.renderInfo}</ItemInfo>;
    $[54] = info;
    $[55] = navItem.renderInfo;
    $[56] = ownerState;
    $[57] = slotProps?.info;
    $[58] = t11;
  } else {
    t11 = $[58];
  }
  let t12;
  if ($[59] !== hasChild || $[60] !== navItem.subItem || $[61] !== ownerState || $[62] !== slotProps?.arrow) {
    t12 = hasChild && <ItemArrow {...ownerState} icon={navItem.subItem ? "eva:arrow-ios-forward-fill" : "eva:arrow-ios-downward-fill"} className={navSectionClasses.item.arrow} sx={slotProps?.arrow} />;
    $[59] = hasChild;
    $[60] = navItem.subItem;
    $[61] = ownerState;
    $[62] = slotProps?.arrow;
    $[63] = t12;
  } else {
    t12 = $[63];
  }
  let t13;
  if ($[64] !== navItem.baseProps || $[65] !== other || $[66] !== ownerState || $[67] !== ref || $[68] !== t10 || $[69] !== t11 || $[70] !== t12 || $[71] !== t5 || $[72] !== t7 || $[73] !== t8 || $[74] !== t9 || $[75] !== title) {
    t13 = <ItemRoot ref={ref} aria-label={title} {...ownerState} {...t4} className={t5} sx={t7} {...other}>{t8}{t9}{t10}{t11}{t12}</ItemRoot>;
    $[64] = navItem.baseProps;
    $[65] = other;
    $[66] = ownerState;
    $[67] = ref;
    $[68] = t10;
    $[69] = t11;
    $[70] = t12;
    $[71] = t5;
    $[72] = t7;
    $[73] = t8;
    $[74] = t9;
    $[75] = title;
    $[76] = t13;
  } else {
    t13 = $[76];
  }
  return t13;
}
const shouldForwardProp = prop => !['open', 'active', 'disabled', 'variant', 'sx'].includes(prop);

/** @slot root */
const ItemRoot = styled(ButtonBase, {
  shouldForwardProp
})(({
  active,
  open,
  theme
}) => {
  const rootItemStyles = {
    padding: 'var(--nav-item-root-padding)',
    minHeight: 'var(--nav-item-root-height)',
    ...(open && {
      color: 'var(--nav-item-root-open-color)',
      backgroundColor: 'var(--nav-item-root-open-bg)'
    }),
    ...(active && {
      color: 'var(--nav-item-root-active-color)',
      backgroundColor: 'var(--nav-item-root-active-bg)',
      '&:hover': {
        backgroundColor: 'var(--nav-item-root-active-hover-bg)'
      },
      ...theme.applyStyles('dark', {
        color: 'var(--nav-item-root-active-color-on-dark)'
      })
    })
  };
  const subItemStyles = {
    padding: 'var(--nav-item-sub-padding)',
    minHeight: 'var(--nav-item-sub-height)',
    color: theme.vars.palette.text.secondary,
    ...(open && {
      color: 'var(--nav-item-sub-open-color)',
      backgroundColor: 'var(--nav-item-sub-open-bg)'
    }),
    ...(active && {
      color: 'var(--nav-item-sub-active-color)',
      backgroundColor: 'var(--nav-item-sub-active-bg)'
    })
  };
  return {
    width: '100%',
    flexShrink: 0,
    color: 'var(--nav-item-color)',
    borderRadius: 'var(--nav-item-radius)',
    '&:hover': {
      backgroundColor: 'var(--nav-item-hover-bg)'
    },
    variants: [{
      props: {
        variant: 'rootItem'
      },
      style: rootItemStyles
    }, {
      props: {
        variant: 'subItem'
      },
      style: subItemStyles
    }, {
      props: {
        disabled: true
      },
      style: navItemStyles.disabled
    }]
  };
});

/** @slot icon */
const ItemIcon = styled('span', {
  shouldForwardProp
})(() => ({
  ...navItemStyles.icon,
  width: 'var(--nav-icon-size)',
  height: 'var(--nav-icon-size)',
  margin: 'var(--nav-icon-root-margin)',
  variants: [{
    props: {
      variant: 'subItem'
    },
    style: {
      margin: 'var(--nav-icon-sub-margin)'
    }
  }]
}));

/** @slot title */
const ItemTitle = styled('span', {
  shouldForwardProp
})(({
  theme
}) => ({
  ...navItemStyles.title(theme),
  ...theme.typography.body2,
  fontWeight: theme.typography.fontWeightMedium,
  variants: [{
    props: {
      active: true
    },
    style: {
      fontWeight: theme.typography.fontWeightSemiBold
    }
  }]
}));

/** @slot caption icon */
const ItemCaptionIcon = styled(Iconify, {
  shouldForwardProp
})(({
  theme
}) => ({
  ...navItemStyles.captionIcon,
  color: 'var(--nav-item-caption-color)',
  variants: [{
    props: {
      variant: 'rootItem'
    },
    style: {
      marginLeft: theme.spacing(0.75)
    }
  }]
}));

/** @slot info */
const ItemInfo = styled('span', {
  shouldForwardProp
})(({
  theme
}) => ({
  ...navItemStyles.info
}));

/** @slot arrow */
const ItemArrow = styled(Iconify, {
  shouldForwardProp
})(({
  theme
}) => ({
  ...navItemStyles.arrow(theme),
  variants: [{
    props: {
      variant: 'subItem'
    },
    style: {
      marginRight: theme.spacing(-0.5)
    }
  }]
}));